import React from "react";

import { stringDateFromUnixDate } from "../../utils/DateUtils";

const DateUnixString: React.FunctionComponent<{ unixDate: string }> = ({
  unixDate,
}) => <span>{stringDateFromUnixDate(unixDate, "DD/MM/YY")}</span>;

export default DateUnixString;
